import React, { useState } from "react";
import { View, Image, TouchableOpacity, StyleSheet } from "react-native";
import { countries, type Country } from "../../types/country-types";
import { Text } from "../Text";
import { fontSizes } from "@/app/constants/styles";

interface CountrySelectorProps {
  selectedCountry: Country;
  onSelectCountry: (country: Country) => void;
}

export const CountrySelector: React.FC<CountrySelectorProps> = ({
  selectedCountry,
  onSelectCountry,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = React.useRef<View>(null);

  return (
    <View ref={containerRef} style={styles.container}>
      <TouchableOpacity
        style={styles.selectedCountry}
        onPress={() => {
          setIsOpen(!isOpen);
        }}
      >
        <Image source={selectedCountry.flag} style={styles.flag} />
        <Text style={styles.prefix}>{selectedCountry.name}</Text>
      </TouchableOpacity>

      {isOpen && (
        <View style={styles.dropdown}>
          {countries.map((country) => (
            <TouchableOpacity
              key={country.code}
              style={styles.option}
              onPress={() => {
                onSelectCountry(country);
                setIsOpen(false);
              }}
            >
              <Image source={country.flag} style={styles.flag} />
              <Text style={styles.prefix}>{country.name}</Text>
            </TouchableOpacity>
          ))}
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginRight: 10,
  },
  selectedCountry: {
    flexDirection: "row",
    alignItems: "center",
    padding: 10,
    borderWidth: 1,
    borderColor: "#ddd",
    borderRadius: 4,
    backgroundColor: "#fff",
  },
  flag: {
    width: 48,
    height: 32,
    marginRight: 10,
  },
  prefix: {
    fontSize: fontSizes.x16,
    color: "#333",
  },
  dropdown: {
    backgroundColor: "#fff",
    borderWidth: 1,
    borderColor: "#ddd",
    borderRadius: 4,
    marginTop: 4,
    maxHeight: 200,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  option: {
    flexDirection: "row",
    alignItems: "center",
    padding: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#eee",
  },
});
